import {Form as MobxReactForm} from 'utils/mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';

const plugins = {dvr: dvr(validatorjs)};

const fields = [
  {
    name: 'email',
    rules: 'required|email',
    options: {validateTrimmedValue: true}
  },
  {
    name: 'password',
    rules: 'required|string'
  },
  {
    name: 'keepSignedIn',
    rules: 'boolean',
    value: true
  }
];

export default () => new MobxReactForm({fields}, {plugins});
